import { create } from 'zustand';

/**
 * 游客模式剩余积分
 *
 * - 数据来源：项目详情接口的 remainingCredits 字段
 * - 初始值 100 仅用于接口数据到达前的首屏占位
 * - 登录成功后 reset()
 */
const DEFAULT_VISITOR_POINTS = 100;

interface VisitorCreditsState {
  userPoints: number;
  setUserPoints: (points: number) => void;
  reset: () => void;
}

export const useVisitorCreditsStore = create<VisitorCreditsState>(set => ({
  userPoints: DEFAULT_VISITOR_POINTS,
  setUserPoints: points => set({ userPoints: Math.max(0, points) }),
  reset: () => set({ userPoints: DEFAULT_VISITOR_POINTS }),
}));
